import { Organisation } from '@/features'
import { ScoresContext } from './context'

export const ScoreReviews = () => {
  const params = ScoresContext.useScoresContext(c => c.params)
  const setParams = ScoresContext.useScoresContext(c => c.setParams)

  return <Organisation.EmployeeReviews {...params} setParams={setParams} />
}
